import React, { useState } from 'react';

function TermsOptInCheckBox({ defaultChecked, action, text }) {
  const [isChecked, setIsChecked] = useState(defaultChecked ?? true);

  const handleChange = (event) => {
    const newChecked = event.target.checked;
    setIsChecked(newChecked);
    if (action) {
      action(newChecked);
    }
  };

  return (
    <div className="full-width-checkBoxContainer ltFormTermsOptInCheckBoxContainer">
      <div className="ltFormCheckBox">
        <input
          type="checkbox"
          id="ltFormTermsOptInCheckBox"
          checked={isChecked}
          onChange={handleChange}
          aria-label="Terms Opt-In CheckBox"
        />
        <label className="boxLabel" htmlFor={`ltFormTermsOptInCheckBox`} />
        <label htmlFor={`ltFormTermsOptInCheckBox`}>{text}</label>
      </div>
    </div>
  );
}

export default TermsOptInCheckBox;
